import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoSpace from 'eco-design/base/eco-space';

export default function K() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('powerbackup');
    const { locale } = useRouter();
    const lists: any = [
        {
            title: t('secK_list1_title'),
            desc: t('secK_list1_desc'),
        },
        {
            title: t('secK_list2_title'),
            desc: t('secK_list2_desc'),
        },
        {
            title: t('secK_list3_title'),
            desc: t('secK_list3_desc'),
        },
    ];
    if (['au'].includes(locale)) {
        lists.push({
            title: t('secK_list4_title'),
            desc: t('secK_list4_desc'),
        });
    }
    if (['us'].includes(locale)) {
        lists.unshift({
            title: t('secK_list4_title'),
            desc: t('secK_list4_desc'),
        });
    }
    return (
        <div id="power-backup-K" className={`power-backup-K ${css['power-backup-K']}`}>
            <EcoSpace />
            <div className="text-box">
                <p className="title">{t('secK_title')}</p>
            </div>
            <Swiper
                className="swiper-box"
                effect="fade"
                modules={[Scrollbar, Navigation]}
                navigation={true}
                spaceBetween={0}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {lists?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <div className="swiper-item-text">
                            <p className="card-desc">{card?.desc}</p>
                            <p className="card-title">{card?.title}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
